import React, { useEffect } from "react";
import { useAtomValue } from "jotai";

import PaymentStatusTemplate, {
  PaymentStatusType,
} from "../../../components/Payments/PaymentStatusTemplate/PaymentStatusTemplate";
import EventDispatcher from "../../../utils/event-dispatcher";
import {
  EventTypes,
  MOBILE_APP_TO_WEB_APP_ROUTE_MAP,
  ROUTES,
} from "../../../utils/constants";
import { renderHeaders } from "../../../utils/renderHeaders";
import XCircleIcon from "../../../components/icons/XCircleIcon";
import useAnalytics from "../../../hooks/useAnalytics";
import useEffectAfterMount from "../../../hooks/useEffectAfterMount";
import { topupInfoAtom, paymentStatusAtom } from "../../../jotai/atoms/topup";

const REDIRECT_ROUTE = ROUTES.WALLET.TOPUP_FAILED;

function PaymentFailedMobile() {
  const { sendCompleteTopupEvent } = useAnalytics();
  const topupInfo = useAtomValue(topupInfoAtom);
  const paymentStatus = useAtomValue(paymentStatusAtom);

  useEffect(() => {
    EventDispatcher.dispatch(EventTypes.PAYMENTS.FAILED, {
      message: "Payment unsuccessful",
    });
    window.location.href = MOBILE_APP_TO_WEB_APP_ROUTE_MAP[REDIRECT_ROUTE];
  }, []);

  useEffectAfterMount(() => {
    if (topupInfo?.provider && paymentStatus) {
      const {
        provider,
        amount,
        price,
        isFirstTime,
        bonusHpr,
        gem,
        topUpUniqueId,
      } = topupInfo;
      sendCompleteTopupEvent({
        hpr_amount: amount,
        bonus_hpr_amount: bonusHpr ?? 0,
        gem_amount: gem ?? 0,
        fiat_amount: price ?? 0,
        first_time_top_up: isFirstTime,
        transaction_status: paymentStatus,
        payment_option: provider.toLowerCase(),
        topUpUniqueId,
      });
    }
  }, [topupInfo, paymentStatus, sendCompleteTopupEvent]);

  return (
    <>
      {renderHeaders({
        title: "Payment Unsuccessful 😢😔 | Hyper by Metaverse Magna",
        description: "",
      })}
      <PaymentStatusTemplate
        type={PaymentStatusType.DONE}
        title="Payment unsuccessful"
        message="Your payment was not successful. You will be redirected to retry top-up"
        eventType={EventTypes.PAYMENTS.FAILED}
        navigateUrl={REDIRECT_ROUTE}
        icon={<XCircleIcon />}
      />
    </>
  );
}

export default PaymentFailedMobile;
